import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Ownership } from '../../model/Ownership';
import { defined } from '../../utility/Control';
import { ApiDate } from '../../realty/model/ApiDate';

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    const ownerships = DataStore.getOwnerships();
    if (ownerships) {
      map(DataStore.getOwnerships(), tag);
    }
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(ownerships: Ownership[], tag: any): void {
  const ownershipPOs: OwnershipPresentationObject[] = [];
  ownerships.forEach((ownership: Ownership) => {
    const ownershipPO: OwnershipPresentationObject = {};
    ownershipPO.ownerName = ownership.name;
    ownershipPO.purchaseDate = ownership.dateRegistered;
    if (defined(ownership.fraction)) {
      ownershipPO.fractionOwned = ownership.fraction.numerator + '/' + ownership.fraction.denominator;
    }
    ownershipPOs.push(ownershipPO);
  });
  tag.ownerships = ownershipPOs;
}

interface OwnershipPresentationObject {
  ownerName?: string;
  purchaseDate?: ApiDate;
  fractionOwned?: string;
}



/** WEBPACK FOOTER **
 ** ./src/components/ownershipDisplay/OwnershipDisplayMapper.ts
 **/